module.exports = __webpack_public_path__ + "img/coinbase.3592b93e.png";